<template>
  <GlobalWindow
    :visible.sync="dialogVisible"
    :show="true"
    title="公共广告列表"
    width="45%"
    @confirm="commit"
  >
    <el-row :gutter="10">
      <el-col :span="6">
        <el-input
          v-model="publicAdvertListParams.ad_name"
          placeholder="输入公共广告名称"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
          />
        </el-input>
      </el-col>
      <el-button
        type="primary"
        @click="searchPublicAdvertList"
      >搜索</el-button>
      <el-button
        type="primary"
        @click="resetPublicAdvertListParams"
      >重置</el-button>
    </el-row>
    <el-table
      v-loading="loading"
      :data="publicAdvertList"
      style="width: 100%"
    >
      <el-table-column
        :key="refreshKey"
        label="选项"
        width="100"
      >
        <template scope="scope">
          <input
            v-model="scope.row.checkboxFlag"
            type="checkbox"
            @click="handleChangeSelect(scope.$index, scope.row)"
          >
          {{ scope.row.$index }}
        </template>
      </el-table-column>
      <el-table-column
        prop="ad_name"
        label="公共广告名称"
        width="180"
      />
      <el-table-column
        prop="id"
        label="公共广告ID"
        width="140"
      />
      <el-table-column
        prop="created_at"
        label="创建时间"
      />
    </el-table>
    <Pagination
      :total="pageTotal"
      :page.sync="publicAdvertListParams.page"
      :limit.sync="publicAdvertListParams.page_size"
      @pagination="fetchPublicAdvertList"
    />
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
import Pagination from '@/components/Pagination/index.vue'
import { publicAdvertList } from '@/api/customer/publicAdvertManage/publicAdvertManage'
import moment from 'moment'

export default {
  name: 'PublicAdvertList',
  components: {
    GlobalWindow,
    Pagination
  },
  data() {
    return {
      dialogVisible: false,
      pageTotal: 0,
      loading: false,
      publicAdvertListParams: {
        ad_name: null,
        page: 1,
        page_size: 10
      },
      refreshKey: 0,
      publicAdvertList: null,
      selectData: null
    }
  },
  methods: {
    // 获取公共广告列表
    fetchPublicAdvertList() {
      this.loading = true
      publicAdvertList(this.publicAdvertListParams).then(res => {
        this.publicAdvertList = res.data.list
        this.publicAdvertList.forEach(item => {
          item.created_at = moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')
          item.checkboxFlag = false
        })
        this.pageTotal = res.data.count
        this.loading = false
      })
    },
    // checkbox单选
    handleChangeSelect(index) {
      if (!this.publicAdvertList[index].checkboxFlag) {
        this.selectData = this.publicAdvertList[index]
      } else {
        this.selectData = null
      }
      this.publicAdvertList.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvertList[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 显示dialog
    open() {
      this.fetchPublicAdvertList()
      this.dialogVisible = true
    },
    // dialog确定按钮事件
    commit() {
      if (!this.selectData) {
        this.$message({
          message: '请选择一项公共广告数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        name: 'CreateTencentAdvert', query: {
          account_id: this.$route.query.account_id,
          id: this.selectData.id, create: true
        }
      })
      this.dialogVisible = false
    },
    // 搜索
    searchPublicAdvertList() {
      this.publicAdvertListParams.page = 1
      this.fetchPublicAdvertList()
    },
    // 重置公共列表请求参数
    resetPublicAdvertListParams() {
      this.publicAdvertListParams = {
        ad_name: null,
        page: 1,
        page_size: 10
      }
      this.fetchPublicAdvertList()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
